export const semanticColorValues = [
    'accent',
    'neutral',
    'info',
    'success',
    'warning',
    'error',
];
//# sourceMappingURL=semantic-color.js.map